export default __webpack_public_path__ + "static/media/economics-da.5c453421.png";